import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TestcaseService {
  private testCaseUrl = '/api/resultpage/testcase/';

  private testCaseUrlNewApptrack =
    '/api/resultpage/creditapplication/testcase/';

  httpOptionsPostTest: Object = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'api-key': 'check24at',
    }),
    responseType: 'text',
  };

  constructor(private http: HttpClient) {}

  getTocken(pathname: string) {
    return this.http
      .post<string>(this.testCaseUrl + pathname, '', this.httpOptionsPostTest)
      .pipe(catchError(this.handleError<string>('getTocken')));
  }

  getTockenNewApptrack(pathname: string) {
    return this.http
      .post<string>(
        this.testCaseUrlNewApptrack + pathname,
        '',
        this.httpOptionsPostTest,
      )
      .pipe(catchError(this.handleError<string>('getTockenNewApptrack')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return throwError(() => {
        return error;
      });
    };
  }
}
